export default __webpack_public_path__ + "static/media/notion_large.aac155fb.svg";